import * as React from 'react'

import * as Style from './style.css'

export type IProps = Omit<
  React.ComponentPropsWithoutRef<'input'>,
  'type' | 'className'
>

export const InputSubmit = React.forwardRef<HTMLInputElement, IProps>(
  (props, ref) => (
    <input className={Style.InputSubmit} {...props} type="submit" ref={ref} />
  ),
)
